const CopyWrite = () => {
    return (
        <div className="container-fluid bg-black">
           <div className="row">
             <div className='copywriteText'>
                <p className="py-3 text-white text-center"> Saptasagar Overseas @2025. All Rights Reserved.</p>
             </div>
           </div>
        </div>
    )
}
export default CopyWrite;